export default __webpack_public_path__ + "static/media/Business_Owned.230cc4b3.pdf";